export class ProyectosConfiguracionComisiones {
  idProyecto: number;
  comision_agente_reda: number;
  comision_asesor_ventas: number;
  comision_rp: number;
  comision_externo: number;
  comision_gerente: number;
  comision_director: number;
  comision_cm: number;
  comision_externo_reda: number;
  estatus: number;
  idUsuarioUM: number;
}
